import { render, staticRenderFns } from "./ChangeEsgDialog.vue?vue&type=template&id=f280bc60"
import script from "./ChangeEsgDialog.vue?vue&type=script&lang=js"
export * from "./ChangeEsgDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports